var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.purchase.actions.customer.supplementary_agreement === "sign"
        ? _c(
            "private-fl44-contract-supplementary-agreement-sign-form-customer",
            {
              attrs: {
                purchase: _vm.purchase,
                "supplementary-agreement": _vm.supplementaryAgreement,
              },
              on: {
                refresh: function ($event) {
                  return _vm.$emit("refresh")
                },
              },
            }
          )
        : _vm.purchase.actions.customer.supplementary_agreement === "reply"
        ? [
            _vm.supplementaryAgreement.type.id === "regular"
              ? _c(
                  "private-fl44-contract-supplementary-agreement-regular-customer-reply-block",
                  {
                    attrs: {
                      purchase: _vm.purchase,
                      "supplementary-agreement": _vm.supplementaryAgreement,
                      contractPriceTotal: _vm.contractPriceTotal,
                    },
                    on: {
                      refresh: function ($event) {
                        return _vm.$emit("refresh")
                      },
                    },
                  }
                )
              : _vm._e(),
            _vm.supplementaryAgreement.type.id === "termination"
              ? _c(
                  "private-fl44-contract-supplementary-agreement-termination-customer-reply-block",
                  {
                    attrs: {
                      purchase: _vm.purchase,
                      "supplementary-agreement": _vm.supplementaryAgreement,
                      contractPriceTotal: _vm.contractPriceTotal,
                    },
                    on: {
                      refresh: function ($event) {
                        return _vm.$emit("refresh")
                      },
                    },
                  }
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }